// api.ts
import axios from "axios";

// Create an axios instance with the base URL for your API.
const api = axios.create({
    baseURL: "https://api.seth-towe.com",
});

// Request interceptor: automatically add the Authorization header.
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor: handle 401 errors.
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Remove the expired token and redirect to login.
            localStorage.removeItem("accessToken");
            window.location.href = "/login";
        }
        return Promise.reject(
            error instanceof Error ? error : new Error(String(error))
        );
    }
);

export default api;
